// import React from "react";
// import { Link } from "react-router";

// const CampaignShowcase = ({ campaign }) => {
//   if (!campaign) return null;

//   return (
//     <section className="campaign-section-main">
//       {/* Background Image or Video */}
//       {campaign.type === "video" ? (
//         <video
//           className="campaign-bg"
//           src={campaign.media}
//           autoPlay
//           loop
//         //   muted
//           playsInline
//         ></video>
//       ) : (
//         <img className="campaign-bg" src={campaign.media} alt={campaign.title} />
//       )}

//       {/* Overlay */}
//       <div className="campaign-overlay"></div>

//       {/* Campaign Content */}
//       <div className="campaign-content">
//         <h2 className="campaign-category">{campaign.category}</h2>
//         <h1 className="campaign-title">{campaign.title}</h1>
//         <p className="campaign-description">{campaign.description}</p>

//         {/* Optional audio control */}
//         {campaign.type === "audio" && (
//           <audio className="campaign-audio" controls src={campaign.media}></audio>
//         )}

//         {/* <button className="campaign-btn">
//           <Link className="area-link" to={campaign.link} state={{campaign:campaign}}>
//                           Learn more →
//           </Link>
//         </button> */}
//         <Link 
//           to={campaign.link} 
//           state={{ campaign: campaign }}
//           className="campaign-btn inline-block text-white bg-blue-600 px-4 py-2 rounded-md hover:bg-blue-700"
//         >
//           Learn more →
//         </Link>
//       </div>
//     </section>
//   );
// };

// export default CampaignShowcase;

import React, { useState,useEffect } from "react";
import { Link } from "react-router-dom"; // corrected import
import { Pencil, TruckElectric } from "lucide-react"; // lightweight icon library
import {
  Box,
  Grid,
  Container,
  Typography,
  Divider,
  CardMedia,
  Avatar,
  Chip,
  Paper,
  Button,
  MenuItem,
  Stack,
  IconButton,
  TextField
} from "@mui/material";

import { Edit as EditIcon, Save as SaveIcon, Close as CloseIcon } from "@mui/icons-material";
import SubCategorySelect from "../Admin/Consumer/SubCategorySelect";

const CampaignShowcase = ({ campaign, isAdminPreview = false, onEdit,isPublicReadDetail,editInside=false }) => {
  

  const [previewData, setPreviewData] = useState(campaign);
  const [editCategory,setEditCategory] = useState(false)
  const [tempCategory,setTempCategory] = useState("")
  const [tempMedia,setTempMedia] = useState("")
  const [editMedia,setEditMedia] = useState(false)
  const [tempTitle,setTempTitle] = useState("")
  const [editTitle,setEditTitle] = useState(false)
  const [tempDescription,setTempDescription] = useState("")
  const [editDescription,setEditDescription] = useState(false)

  useEffect(() => {
    setPreviewData(prev => {
      // only update if campaign actually changed
      if (JSON.stringify(prev) !== JSON.stringify(campaign)) {
        return campaign;
      }
      return prev;
    });
  }, [campaign]);
  

  useEffect(()=>{
    if(previewData){
      setTempDescription(previewData?.description)
      setTempTitle(previewData?.title)
      setTempMedia(previewData?.media)
      setTempCategory(previewData?.category?.name)
    }
  },[previewData])


  useEffect(()=>{
    if(editInside===true){
    onEdit(previewData)
    }
  },[editInside,previewData])

  if (!campaign) return null;

  const handleSaveCategory = (e)=>{
    setPreviewData((prev)=>({...prev,category:tempCategory}))
    setTempCategory("")
    setEditCategory(false)
  }
  const handleCancelCategory = (e)=>{
    setTempCategory("")
    setEditCategory(false)
  }

  const handleSaveTitle = (e)=>{
    setPreviewData((prev)=>({...prev,title:tempTitle}))
    setTempTitle("")
    setEditTitle(false)
  }
  const handleCancelTitle = (e)=>{
    // setTempTitle("")
    setEditTitle(false)
  }

  const handleSaveDescription = (e)=>{
    e.preventDefault()
    setPreviewData((prev)=>({...prev,description:tempDescription}))
    setTempDescription("")
    setEditDescription(false)
  }
  const handleCancelDescription = (e)=>{
    // setTempDescription("")
    setEditDescription(false)
  }

  
  

  return (
    <section className="campaign-section-main relative">
      {/* Background Image or Video */}
      {previewData.type === "video" ? (
        <video
          className="campaign-bg"
          src={previewData.media}
          autoPlay
          loop
          playsInline
        ></video>
      ) : (
        <img
          className="campaign-bg"
          src={previewData.media}
          alt={previewData.title}
        />
      )}

      {/* Overlay */}
      <div className="campaign-overlay"></div>

      {/* Campaign Content */}
      <div className="campaign-content relative z-10">
        {/* Category */}
        <div className="flex items-center gap-2">
          {editCategory===false?
          (<h2 className="campaign-category">{previewData.category?.name}</h2>):
          <Stack direction="row" alignItems="center" spacing={1} sx={{ width: "100%" }}>
            {/* <TextField
              select
              fullWidth
              size="small"
              value={tempCategory}
              onChange={(e)=>(setTempCategory(e.target.value))}
              variant="outlined"
              autoFocus
            >
              <MenuItem value="image">Health</MenuItem>
              <MenuItem value="video">Income</MenuItem>
              <MenuItem value="audio">Mothers</MenuItem>
            </TextField> */}
            <SubCategorySelect />
            <IconButton onClick={handleSaveCategory} color="success">
              <SaveIcon />
            </IconButton>
            <IconButton onClick={handleCancelCategory} color="error">
              <CloseIcon />
            </IconButton>
          </Stack>}
          {isAdminPreview && editInside &&(
            <Pencil
              size={16}
              className="cursor-pointer text-gray-500 hover:text-blue-600"
              onClick={(e) =>{setEditCategory(true)}}
            />
          )}
        </div>

        {/* Title */}
        <div className="flex items-center gap-2">
        {editTitle===false?
          (<h1 className="campaign-title">{previewData.title}</h1>):
          (
            <Stack direction="row" alignItems="center" spacing={1} sx={{ width: "100%" }}>
            <TextField
              fullWidth
              size="small"
              value={tempTitle}
              onChange={(e)=>(setTempTitle(e.target.value))}
              variant="outlined"
              autoFocus
              multiline
              rows={2}
              sx={{
                "& .MuiInputBase-input": {
                  color: "white",          // text color
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "white",  // default border
                  },
                  "&:hover fieldset": {
                    borderColor: "#cccccc", // hover border
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#1976d2", // focused border
                  },
                },
                "& .MuiInputLabel-root": {
                  color: "white",          // label color
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#1976d2",        // focused label color
                },
                "& .MuiInputBase-root": {
                  backgroundColor: "rgba(103, 102, 102, 0.05)",
                }
              }}
            />
            <IconButton onClick={handleSaveTitle} color="success">
              <SaveIcon />
            </IconButton>
            <IconButton onClick={handleCancelTitle} color="error">
              <CloseIcon />
            </IconButton>
          </Stack>
          )}

          {isAdminPreview && editInside && (
            <Pencil
              size={18}
              className="cursor-pointer text-gray-500 hover:text-blue-600"
              onClick={(e) =>{setEditTitle(true)}}
            />
          )}
        </div>

        {/* Description */}
        <div className="flex items-start gap-2">
          {editDescription===false?(<p className="campaign-description">{previewData.description}</p>):
          (
            <Stack direction="row" alignItems="center" spacing={1} sx={{ width: "100%" }}>
            <TextField
              fullWidth
              value={tempDescription}
              onChange={(e)=>(setTempDescription(e.target.value))}
              variant="outlined"
              autoFocus
              multiline
              rows={4}
              sx={{
                "& .MuiInputBase-input": {
                  color: "white",          // text color
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "white",  // default border
                  },
                  "&:hover fieldset": {
                    borderColor: "#cccccc", // hover border
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#1976d2", // focused border
                  },
                },
                "& .MuiInputLabel-root": {
                  color: "white",          // label color
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#1976d2",        // focused label color
                },
                "& .MuiInputBase-root": {
                  backgroundColor: "rgba(95, 95, 95, 0.05)",
                }
              }}
            >
            </TextField>
            <IconButton onClick={handleSaveDescription} color="success">
              <SaveIcon />
            </IconButton>
            <IconButton onClick={handleCancelDescription} color="error">
              <CloseIcon />
            </IconButton>
          </Stack>
          )}
          {isAdminPreview && editInside &&(
            <Pencil
              size={14}
              className="cursor-pointer text-gray-500 hover:text-blue-600 mt-1"
              onClick={() => setEditDescription(true)}
            />
          )}
        </div>

        {/* Optional audio control */}
        {previewData.type === "audio" && (
          <audio
            className="campaign-audio"
            controls
            src={previewData.media}
          ></audio>
        )}

        {/* Learn More Button */}
        {!isAdminPreview && !isPublicReadDetail && (
          <Link
            to={`/campaign/campaigndetail/${previewData?.id}/`}
            state={{ campaign: previewData }}
            // className="campaign-btn inline-block text-white bg-blue-600 px-4 py-2 rounded-md hover:bg-blue-700"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              backgroundColor: "#22C55E", // green
              color: "white",
              padding: "10px 20px",
              borderRadius: "9999px",
              fontWeight: "600",
              fontSize: "16px",
              border: "none",
              cursor: "pointer",
              transition: "background-color 0.2s ease"
            }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#c18078")} // blue-600
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#22C55E")} // green
          >
            Learn more →
          </Link>
        )}
      </div>
    </section>
  );
};

export default CampaignShowcase;